var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMacProfiIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.055 11.0275C21.055 18.19 11.0275 24.875 11.0275 24.875C11.0275 24.875 1 18.19 1 11.0275C1 8.36804 2.05647 5.81751 3.93699 3.93699C5.81751 2.05647 8.36804 1 11.0275 1C13.687 1 16.2375 2.05647 18.118 3.93699C19.9985 5.81751 21.055 8.36804 21.055 11.0275V11.0275Z",
    stroke: "#02E2FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0271 13.415C12.3457 13.415 13.4146 12.3461 13.4146 11.0275C13.4146 9.70893 12.3457 8.64001 11.0271 8.64001C9.70857 8.64001 8.63965 9.70893 8.63965 11.0275C8.63965 12.3461 9.70857 13.415 11.0271 13.415Z",
    fill: "#02E2FF",
    stroke: "#02E2FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacProfiIcon1);
export default __webpack_public_path__ + "static/media/mac-profi_icon1.ecf0940ddd21023ba5fd535492da33bf.svg";
export { ForwardRef as ReactComponent };